import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import SignalWifi4BarOutlinedIcon from '@mui/icons-material/SignalWifi4BarOutlined';
import NetworkWifiOutlinedIcon from '@mui/icons-material/NetworkWifiOutlined';
import NetworkWifi3BarOutlinedIcon from '@mui/icons-material/NetworkWifi3BarOutlined';
import NetworkWifi2BarOutlinedIcon from '@mui/icons-material/NetworkWifi2BarOutlined';
import NetworkWifi1BarOutlinedIcon from '@mui/icons-material/NetworkWifi1BarOutlined';
//import SignalWifi0BarOutlinedIcon from '@mui/icons-material/SignalWifi0BarOutlined';
import { getFromRange } from '@iotv/datamodel-core';
const rssiToStrengthRanges = [
    { low: -60, high: null, value: (props) => _jsx(SignalWifi4BarOutlinedIcon, { ...props }) },
    { low: -80, high: -60, value: (props) => _jsx(NetworkWifiOutlinedIcon, { ...props }) },
    { low: -90, high: -80, value: (props) => _jsx(NetworkWifi3BarOutlinedIcon, { ...props }) },
    { low: -100, high: -90, value: (props) => _jsx(NetworkWifi2BarOutlinedIcon, { ...props }) },
    { low: null, high: -100, value: (props) => _jsx(NetworkWifi1BarOutlinedIcon, { ...props }) },
];
export const RSSISignalStrengthIndicator = ({ rssi, iconProps }) => {
    const signalIcon = getFromRange(rssiToStrengthRanges, rssi);
    return signalIcon ? signalIcon(iconProps ?? {}) : _jsx(_Fragment, {});
};
